// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --ds-avatar-link-border-color: transparent;
    --ds-avatar-link-hover-border-color: var(--ds-color-grey-indigo-30);
    --ds-avatar-link-selected-border-color: var(--ds-color-grey-10);
}

.WorkspaceBar-module__Bar__m9rri {
    width: var(--ds-18x);
    padding: var(--ds-s);
    background-color: var(--ds-box-level1-bg-color);
    border-right: var(--ds-border-width) solid var(--ds-color-grey-indigo-50);
    transition: var(--ds-transition-s);
}

.WorkspaceBar-module__Hidden__H7wuA {
    width: 0;
    padding: 0;
    border-right-width: 0;
    transition: var(--ds-transition-s) var(--ds-transition-s);
}

@keyframes WorkspaceBar-module__hide__GwnZn {
    0% {
        visibility: visible;
        opacity: 1;
    }

    99% {
        opacity: 0;
    }

    100% {
        visibility: hidden;
        opacity: 0;
    }
}

.WorkspaceBar-module__BarItemWrapper__qkZ_4 {
    position: relative;
    transition: opacity var(--ds-transition-s) ease-in-out 250ms;
}

.WorkspaceBar-module__BarItemHideable__Cqbgj {
    transition: opacity var(--ds-transition-s) ease-in-out 250ms;
}
/* stylelint-disable-next-line selector-max-specificity -- animation */
.WorkspaceBar-module__Hidden__H7wuA .WorkspaceBar-module__BarItemHideable__Cqbgj {
    visibility: hidden;
    opacity: 0;
    animation: WorkspaceBar-module__hide__GwnZn var(--ds-transition-s);
}

.WorkspaceBar-module__AvatarLink__RvAiL {
    display: flex;
    justify-content: center;
    margin: var(--ds-border-width-double);
    padding: var(--ds-border-width-double);
    border-radius: calc(
        var(--ds-border-radius-s) + var(--ds-border-width-double)
    );
    outline: var(--ds-border-width-double) solid
        var(--ds-avatar-link-border-color);
}

.WorkspaceBar-module__AvatarLink__RvAiL:hover {
    outline-color: var(--ds-avatar-link-hover-border-color);
}

.WorkspaceBar-module__AvatarLinkSelected__a_YaE {
    outline-color: var(--ds-avatar-link-selected-border-color);
}

.WorkspaceBar-module__AvatarLink__RvAiL:focus {
    border-radius: var(--ds-border-radius-s);
}
/* There is an artifact/bar/rectangle which appears while the bar is resizing */
.WorkspaceBar-module__OverflowFix__Xo3jk {
    overflow-x: hidden;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Bar": `WorkspaceBar-module__Bar__m9rri`,
	"Hidden": `WorkspaceBar-module__Hidden__H7wuA`,
	"BarItemWrapper": `WorkspaceBar-module__BarItemWrapper__qkZ_4`,
	"BarItemHideable": `WorkspaceBar-module__BarItemHideable__Cqbgj`,
	"hide": `WorkspaceBar-module__hide__GwnZn`,
	"AvatarLink": `WorkspaceBar-module__AvatarLink__RvAiL`,
	"AvatarLinkSelected": `WorkspaceBar-module__AvatarLinkSelected__a_YaE`,
	"OverflowFix": `WorkspaceBar-module__OverflowFix__Xo3jk`
};
export default ___CSS_LOADER_EXPORT___;
